<template>
  <div>
    <div class="d-flex gap-5">
      <div class="flex-4 form-control text-muted fw-bolder d-flex gap-2 align-items-center">
        <div v-for="uuid in breadcrumbs" class="d-flex align-items-center justify-content-center gap-3 text-uppercase" @click="openItem(uuid)">
          <div class="text-hover-primary cursor-pointer">
            {{ items[uuid].alias }}
          </div>
          <div class="d-flex justify-content-center align-items-center mx-1">
            <i class="fad fa-angle-right"></i>
          </div>
        </div>
      </div>
      <div class="flex-2">
        <input class="form-control" placeholder="Rechercher" type="text">
      </div>
    </div>
    <div class="d-flex flex-4 min-h-500px border-1 border my-5 rounded border-gray-300">
      <div id="folder-container" ref="folderContainer" class="flex-4 position-relative" @click="selectItem(currentItemUuid)">
        <template v-if="itemType">
          <template v-for="property in itemType.properties">
            <div v-if="property.type.code.includes('OBJECT') && itemTypes[property.itemCode]">
              <div class="border-bottom border-bottom-1 border-gray-300 fw-bolder cursor-pointer  px-5 py-2 rounded d-flex align-items-center gap-5 text-uppercase" @click.prevent.stop>
                <div class="d-flex align-items-center gap-2">
                  <i class="fad fa-angle-down"></i>
                  <i :class="itemTypes[property.itemCode].icon+' fs-2'"></i>
                  {{ property.name }}
                </div>
                <div class="badge badge-light-success">
                  <!--                  {{ item.children.length }}-->
                  /{{ item.childrenMap[property.code] }}
                </div>
              </div>

              <div v-if="item.children && item.children[itemTypes[property.itemCode].code]" class="d-flex flex-wrap gap-5 m-5">
                <div v-for="childUuid in item.children[itemTypes[property.itemCode].code]" :id="'children_'+childUuid"
                     :class="{ 'bg-light-primary' : selectedUuid === childUuid }"
                     class="cursor-pointer border border-1 border-gray-300 p-5  rounded d-flex flex-column justify-content-center align-items-center position-relative w-150px text-center"
                     style="user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;aspect-ratio: 15 / 16"
                     @dblclick="openItem(childUuid)"
                     @click.prevent.stop="selectItem(childUuid)"
                     @contextmenu.prevent.stop="showMenu($event, childUuid)"
                >
                  <div v-if="itemTypes[property.itemCode].className === 'Asset'" class="position-absolute" style="top:10px;right:10px;">
                    <i class="fad fa-shield-alt fs-2 text-muted"></i>
                  </div>
                  <div>
                    <i :class="itemTypes[property.itemCode].icon+' fs-3x'"></i>
                  </div>
                  <div v-if="items[childUuid].alias" class="text-muted fw-bolder mt-2">
                    {{ items[childUuid].alias }}
                  </div>
                  <div v-if="items[childUuid].identifier" class="fw-bolder">
                    {{ items[childUuid].identifier }}
                  </div>
                  <div v-if="items[childUuid].coverage" class="badge badge-primary">
                    {{ items[childUuid].coverage.label }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>


        <div v-if="menuVisible"
             ref="contextMenu"
             :style="{ top: menuY + 'px', left: menuX + 'px', zIndex: 9999, minWidth: '200px' }"
             class="position-absolute bg-white border border-gray-300 rounded shadow-lg py-2"
             @click.stop>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-primary" @click="handleMenuAction('open')">
            <i class="fad fa-folder-open me-2"></i>
            Ouvrir
          </div>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-primary" @click="handleMenuAction('edit')">
            <i class="fad fa-edit me-2"></i>
            Modifier
          </div>
          <div class="border-top border-gray-300 my-1"></div>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-danger text-danger" @click="handleMenuAction('delete')">
            <i class="fad fa-trash me-2"></i>
            Supprimer
          </div>
        </div>

      </div>
      <div class="flex-2  border-gray-300" style="border-width:0;border-left-width: 1px;border-style: solid">
        <div v-if="selectedUuid" class="d-flex flex-column">
          <div class="flex-1 d-flex flex-column justify-content-center align-items-center py-5 ">
            <!--            <div>-->
            <!--              <i :class="itemTypes[items[selectedUuid].modelCode].icon+' fs-5tx'"></i>-->
            <!--            </div>-->
            <div class="fw-bolder text-muted fs-2 gap-5 d-flex align-items-center">
              <div>
                {{ items[selectedUuid].name }}
              </div>
              <i class="fad fa-edit text-muted fs-2 cursor-pointer"></i>
            </div>
            <div class="fw-bolder  gap-5 d-flex align-items-center">
              <div>
                {{ items[selectedUuid].identifier }}
              </div>
              <i class="fad fa-sync text-muted  cursor-pointer"></i>
            </div>
          </div>

          <b-tabs>
            <b-tab>
              <template #title>
                Propriétés
              </template>
              <div class="mh-400px overflow-auto">
                <table class="table table-striped gx-5">
                  <tbody>
                  <template v-for="(value,key) in items[selectedUuid].properties">
                    <tr v-if="!itemTypes[items[selectedUuid].modelCode].properties[key].type.code.includes('OBJECT') " :key="'detail_prop_'+selectedUuid+'_'+key">
                      <td class="fw-bolder">
                        {{ itemTypes[items[selectedUuid].modelCode].properties[key].name }}
                      </td>
                      <td class="text-end">
                        {{ formattedValue(itemTypes[items[selectedUuid].modelCode].properties[key], value) }}
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab v-if="itemTypes[items[selectedUuid].modelCode].className === 'Asset'">
              <template #title>
                Couvertures
              </template>
            </b-tab>
          </b-tabs>

        </div>
        <LoadingLogo v-if="isLoading"/>

      </div>
    </div>

  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {helper} from "@/services/Helper";
import AssetViewer from "@/components/AssetViewer.vue";
import ObjectViewer from "@/components/ObjectNavigator/ObjectViewer.vue";
import {api} from "@/services/Api";
import Property from "@/entity/Property";
import LoadingLogo from "@/components/LoadingLogo.vue";

@Component({
  components: {LoadingLogo, ObjectViewer, AssetViewer}
})
export default class ObjectNavigator extends Vue {
  @Prop({default: ''}) uuid?: string
  breadcrumbs = []
  filter = {type: null, page: 1, perPage: 50}
  items = {}
  currentItemUuid: string = '';
  children = {};
  childrenCount = {};
  pageLoaded = {};
  menuVisible = false
  menuX = 0
  menuY = 0
  selectedUuid = null
  isLoading = false
  scrollOffset = {x: 0, y: 0}
  targetElement = null

  get item() {
    return this.items[this.currentItemUuid]
  }

  get itemType() {
    if (this.item) {
      return this.itemTypes[this.item.modelCode];
    }
  }

  get itemTypes() {
    return this.$store.state.contractStore.itemTypes;
  }

  getItemType(code: string) {
    if (this.item) {
      return this.itemTypes[code];
    }
  }

  selectItem(uuid) {
    this.selectedUuid = uuid
  }

  showMenu(e: MouseEvent, uuid: string) {
    e.preventDefault();
    this.selectedUuid = uuid;

    const container = this.$refs.folderContainer as HTMLElement;
    const containerRect = container.getBoundingClientRect();

    this.menuX = e.clientX - containerRect.left + 5;
    this.menuY = e.clientY - containerRect.top + 5;

    this.menuVisible = true;
  }


  hideMenu() {
    this.menuVisible = false;
    this.selectedUuid = null;
    this.targetElement = null;
  }

  handleMenuAction(action: string) {
    this.hideMenu()
  }

  mounted() {
    if (helper.empty(this.itemTypes)) {
      console.log('ContractStore itemTypes is empty')
      return
    }
    this.openItem(this.uuid)
    this.$nextTick(() => {
      if (this.$refs.folderContainer) {
        (this as any).$addListener(this.$refs.folderContainer, 'click', this.hideMenu);
        (this as any).$addListener(this.$refs.folderContainer, 'contextmenu', this.hideMenu);
      }
    });
  }

  formattedValue(model, value) {
    try {
      if (model['type']['format'] === 'DATE') {
        return helper.readable(new Date(value as any), ('dmY'))
      }
      if (model['type']['code'] === 'AMOUNT' || model['type']['code'] === 'NUMBER') {
        return helper.currencyFormat(value, false, false)
      }

      if (model['type']['code'] === 'NUMBER') {
        return helper.currencyFormat(value, false, false)
      }

      if (model['type']['code'] === 'RADIO') {
        const choice = Object.values(model.choices).find((c: any) => {
          return c.code === value
        }) as any
        return choice?.label
      }
      if (model['type']['code'] === 'BOOLEAN') {
        return value as any === true || value === 'true' ? 'Oui' : 'Non'
      }
      if (model['type']['code'] === 'PACK') {
        const pack = JSON.parse(value as any)
        return value as any === true || value === 'true' ? 'Oui' : 'Non'
      }
    } catch (e) {
    }
    return !helper.empty(value) ? value : '-'
  }

  openItem(uuid: string) {
    if (!this.items[uuid] && uuid !== this.uuid) {
      return;
    }
    if (this.items[uuid] && this.items[uuid].childrenCount === 0) {
      return
    }
    this.currentItemUuid = uuid;
    if (!this.items[uuid] || !this.items[uuid].children) {
      this.loadChildren(uuid);
    } else {
      this.buildBreadcrumbFromCurrent()
    }
  }

  clickBreadcrumb(index: number) {
    const item = this.breadcrumbs[index];
    this.currentItemUuid = item.uuid;
    this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
    if (item.childrenCount > 0) {
      this.loadChildren(item.uuid);
    }
  }

  buildBreadcrumbFromCurrent() {
    const trail = [];
    let currentUuid: string | null = this.currentItemUuid;
    while (currentUuid) {
      if (currentUuid === this.uuid) {
        break;
      }
      const item = this.items[currentUuid];
      if (!this.items[currentUuid]) break;
      if (helper.empty(this.items[currentUuid].alias)) {
        this.generateAlias(currentUuid)
      }
      trail.unshift(currentUuid);
      currentUuid = (item as any).parentItem || null;

    }
    if (helper.empty(this.items[this.uuid].alias)) {
      this.generateAlias(this.uuid)
    }
    trail.unshift(this.uuid);
    this.breadcrumbs = trail;
  }


  async loadRoot() {

  }

  generateAlias(uuid: any) {
    let generated = "";
    if (!this.items[uuid]) return

    generated = this.items[uuid].alias ?? this.items[uuid].name
    if (helper.empty(generated)) {
      const it = this.itemTypes[this.items[uuid].modelCode]
      if (!it) return
      Object.values(it.properties).forEach((pModel: any) => {
        if (pModel.isAlias && !pModel.type.code.match(/OBJECT/)) {
          if (!this.items[uuid]['properties']) {
            return
          }
          let value = this.items[uuid]['properties'][pModel.code];
          if (!helper.empty(value)) {
            generated += value
          }
        } else {

        }
      })
      if (helper.empty(generated.trim())) {
        generated = it.name
      }
      generated = generated.trim()
    }
    this.items[uuid].alias = generated
    return generated;
  }

  generateIdentifier(self: any) {
    let identifier = "";
    Object.values(self.properties).forEach((p: Property) => {
      if (p.model.identifier) {
        if (!helper.empty(p.value)) {
          if (!helper.empty(identifier)) {
            identifier += ' ';
          }
          identifier += p.value
        }
      }
    });
    identifier = identifier.trim()

    return identifier;
  }

  async loadChildren(uuid, type = null, page = 1, limit = 50) {
    this.currentItemUuid = uuid
    const includeParent = !this.items[uuid]
    this.isLoading = true
    const res = await api.post(api.core, `contract/item/${uuid}/children`, {type, page, limit, includeParent});
    this.isLoading = false
    if (res?.data?.items) {
      if (includeParent) {
        this.items[uuid] = res.data.items[uuid]
      }
      if (!this.items[uuid].children) {
        this.$set(this.items[uuid], 'children', {});
      }

      Object.entries(res.data.items).forEach(([childUuid, item]: [string, any]) => {
        this.$set(this.items, childUuid, item);
        if (helper.empty(item.alias)) {
          this.generateAlias(childUuid)
        }

        if (childUuid !== uuid) {
          if (!this.items[uuid].children[item.modelCode]) {
            this.$set(this.items[uuid].children, item.modelCode, []);
          }
          if (!this.items[uuid].children[item.modelCode].includes(childUuid)) {
            this.items[uuid].children[item.modelCode].push(childUuid)
          }
        }
      })
      this.selectedUuid = uuid
      this.buildBreadcrumbFromCurrent()
      this.$forceUpdate();
    }
  }

  async loadItems() {

  }
}
</script>

<style scoped>

</style>